module.exports = __webpack_public_path__ + "img/pr-19.d86707a7.png";